import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import Layout from "@/components/app/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Missions from "@/pages/Missions";
import TimeTracking from "@/pages/TimeTracking";
import EngagementLetters from "@/pages/EngagementLetters";
import WorkPrograms from "@/pages/WorkPrograms";
import LcbFt from "@/pages/LcbFt";
import QualityControl from "@/pages/QualityControl";
import Echeances from "@/pages/Echeances";
import Collaborators from "@/pages/Collaborators";
import Accounting from "@/pages/accounting/Accounting";
import AccountingFile from "@/pages/accounting/AccountingFile";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<ProtectedRoute module="clients"><Clients /></ProtectedRoute>} />
              <Route path="/missions" element={<ProtectedRoute module="missions"><Missions /></ProtectedRoute>} />
              <Route path="/temps" element={<ProtectedRoute module="time"><TimeTracking /></ProtectedRoute>} />
              <Route path="/lettres-mission" element={<ProtectedRoute module="letters"><EngagementLetters /></ProtectedRoute>} />
              <Route path="/programmes-travail" element={<ProtectedRoute module="programs"><WorkPrograms /></ProtectedRoute>} />
              <Route path="/lcb-ft" element={<ProtectedRoute module="lcbft"><LcbFt /></ProtectedRoute>} />
              <Route path="/controle-qualite" element={<ProtectedRoute module="qc"><QualityControl /></ProtectedRoute>} />
              <Route path="/controle-qualite/:reviewId" element={<ProtectedRoute module="qc"><QualityControl /></ProtectedRoute>} />
              <Route path="/echeances" element={<ProtectedRoute module="echeances"><Echeances /></ProtectedRoute>} />
              <Route path="/comptabilite" element={<ProtectedRoute module="accounting"><Accounting /></ProtectedRoute>} />
              <Route path="/comptabilite/:fileId" element={<ProtectedRoute module="accounting"><AccountingFile /></ProtectedRoute>} />
              <Route path="/collaborateurs" element={<ProtectedRoute module="users"><Collaborators /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
